import * as React from 'react';

import * as style from './styles.css';
import { CloseButton } from '../CloseButton';

export interface IABFullscreenGalleryHeaderProps {
  title: React.ReactNode;
  favoriteButton: React.ReactNode;
  callButton: React.ReactNode;
  onClose: () => void;
}

export const ABHeader: React.FC<React.PropsWithChildren<IABFullscreenGalleryHeaderProps>> = ({
  title,
  favoriteButton,
  callButton,
  onClose,
}) => {
  return (
    <div className={style['container']}>
      {title}

      <div className={style['aside']}>
        <div className={style['buttons']}>
          <div className={style['button']}>{callButton}</div>
          <div className={style['button']}>{favoriteButton}</div>
        </div>

        <CloseButton onClick={onClose} />
      </div>
    </div>
  );
};
